import {
  Breadcrumb,
  BreadcrumbGroup,
  Column,
  Icon,
  Row,
  Text,
} from "@amzn/meridian";
import { useNavigate } from "react-router-dom";
import exportLargeTokens from "@amzn/meridian-tokens/base/icon/export-large";
import { useAppDispatch } from "src/store/store";
import { setSideMenuSelectedHash } from "src/store/uiSlice";
import "./helpAndSupport.scss";

const HelpAndSupportPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const goToHome = () => {
    dispatch(setSideMenuSelectedHash("#newChat"));
    navigate("/");
  };

  return (
    <div className="help-and-support">
      <Column spacing="500" className="help-content">
        <BreadcrumbGroup>
          <Breadcrumb onClick={goToHome}>Homepage</Breadcrumb>
          <Breadcrumb href="/help-and-support">Help and Support</Breadcrumb>
        </BreadcrumbGroup>

        <Text type="d100" fontFamily="bookerly">
          Help and Support
        </Text>

        <Row
          spacing="500"
          alignmentVertical="stretch"
          widths={["fill", "fill"]}
          wrap="down"
          className="help-cards-row"
        >
          <div className="help-card">
            <Column
              spacing="300"
              height="100%"
              heights={["fit", "fill", "fit"]}
            >
              <Text type="h200" className="help-card-title">
                Share Your Feedback
              </Text>
              <Text type="b300" color="secondary">
                Have ideas on how to make SAIGE better? We want to hear from
                you. Whether it&apos;s a feature request, a missing procedure,
                or general feedback on your experience, your input helps shape
                the product roadmap.
              </Text>
              <a
                href="https://issues.amazon.com/issues/create?template=c9970d52-3ccc-447d-9ead-dacdbf5349ae"
                target="_blank"
                rel="noreferrer"
                className="help-link-button"
              >
                <span>Share Feedback</span>
                <Icon tokens={exportLargeTokens} />
              </a>
            </Column>
          </div>
          <div className="help-card">
            <Column
              spacing="300"
              height="100%"
              heights={["fit", "fill", "fit"]}
            >
              <Text type="h200" className="help-card-title">
                Report Issue
              </Text>
              <Text type="b300" color="secondary">
                Experiencing a technical issue or seeing incorrect information?
                Let us know so we can investigate and resolve it. Please include
                details about what you were searching for and what went wrong.
              </Text>
              <a
                href="https://issues.amazon.com/issues/create?template=803dbc41-826a-4b8c-8e31-3281a93ba5f3"
                target="_blank"
                rel="noreferrer"
                className="help-link-button"
              >
                <span>Report Issue</span>
                <Icon tokens={exportLargeTokens} />
              </a>
            </Column>
          </div>
        </Row>
      </Column>
    </div>
  );
};

export default HelpAndSupportPage;
